<template>
  <v-container class="communications-admin" id="communications-container">
    <div class="boxes">
      <div class="maintitle">&nbsp;</div>
      <v-row class="row-boxes">
        <v-col cols="3" xs="3">
          <div class="communication">
            <img
              src="@/assets/comunicazioni_mobile.png"
              @click="navigateTo('loadCommunication', true)"
            />
          </div>
        </v-col>
        <v-col cols="3" xs="3">
          <div class="communication">
            <img
              id="imgHistory"
              src="@/assets/comunicazioni_storico.png"
              @click="navigateTo('loadCommunication', false)"
            />
          </div>
        </v-col>
      </v-row>
    </div>

    <div class="boxes second-row">
      <v-row class="row-boxes">
        <v-col cols="3" sm="3" class="second-row-col">
          <v-btn
            class="generic-button"
            @click="navigateTo('loadCommunication', true)"
            >{{ $t("Communications.loadCommunications") }}</v-btn
          >
        </v-col>
        <v-col cols="3" sm="3" class="second-row-col">
          <v-btn
            class="generic-button"
            @click="navigateTo('loadCommunication', false)"
            >{{ $t("Communications.communicationsHystory") }}</v-btn
          >
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<style>
.communication {
  border: 4px solid #6f767a;
}
.communication img {
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.communications-admin .second-row-col {
  position: relative;
}

.communications-admin .generic-button {
  position: absolute;
  left: 50%;
  text-transform: uppercase;
  transform: translateX(-50%);
}

.communications-admin .communication {
  margin-left: 50px;
  margin-right: 50px;
}

.communication #imgHistory {
  height: 110%;
  left: 58%;
  transform: translateX(-50%);
  top: -28px;
}
</style>
<script>
import router from "@/router/index.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";

export default {
  async created() {

    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      var user = this.$GAUserAuth.user;

      MyFercamApi.IsAdmin(user.username).then((data) => {
        var isAdmin = data.data;

        if(!isAdmin){
          router.push({ name: "home" });
        }

        this.closeMenu();
      });
    });
      
  },
  methods: {
    closeMenu() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
    navigateTo(component, isLoad) {
      router
        .push({ name: component, params: { isLoad: isLoad } })
        .catch((err) => {
          this.close();
        });
    },
  },
};
</script>


